export enum HallowDataTestId {
  AlreadyHaveAccountButton = "already-have-account-button",
  AuthContinueButton = "auth-continue-button",
  AuthContinueWithAppleButton = "auth-continue-with-apple-button",
  AuthContinueWithGoogleButton = "auth-continue-with-google-button",
  AuthFirstNameInput = "auth-first-name-input",
  AuthLastNameInput = "auth-last-name-input",
  AuthContinueWithPhoneOrEmailButton = "auth-continue-with-phone-or-email-button",
  AuthContinueWithEmailOrUsernameButton = "auth-continue-with-email-or-username-button",
  AuthSubmitButton = "auth-submit-button",
  AuthUseEmailInsteadButton = "auth-use-email-instead-button",
  AuthUsePasswordInsteadButton = "auth-use-password-instead-button",
  Cart = "cart",
  CartDetailsTrigger = "cart-details-trigger",
  CollectionTitle = "collection-title",
  CommunityTypeTitle = "community-type-title",
  ConsentModalTitle = "consent-modal-title",
  ContentCTAButton = "content-cta-button",
  ContentDescription = "content-description",
  ContentMedium = "content-medium",
  ContentSmall = "content-small",
  ContentTitle = "content-title",
  CreditOrDebitCardEmailInput = "credit-or-debit-card-email-input",
  CreditOrDebitCardNameInput = "credit-or-debit-card-name-input",
  CreditOrDebitCardTrigger = "credit-or-debit-card-trigger",
  DialogPrimaryButton = "dialog-primary-button",
  DownloadBannerHeaderDesktop = "download-banner-header-desktop",
  DownloadBannerHeaderMobile = "download-banner-header-mobile",
  DytDescription = "dyt-description",
  DytToggleGroupItem = "dyt-toggle-group-item",
  DytToggleGroupItemDescription = "dyt-toggle-group-item-description",
  DytToggleGroupItemTitle = "dyt-toggle-group-item-title",
  Errors = "errors",
  HomeIconFilled = "home-icon-filled",
  Main = "main",
  MediaBackgroundOption = "media-background-option",
  MediaBackgroundVolume = "media-background-volume",
  MediaClose = "media-close",
  MediaCollapse = "media-collapse",
  MediaElapsed = "media-elapsed",
  MediaFullscreen = "media-fullscreen",
  MediaGuideOption = "media-guide-option",
  MediaLengthOption = "media-length-option",
  MediaPlayer = "media-player",
  MediaPlayPause = "media-play-pause",
  MediaQueueHandle = "media-queue-handle",
  MediaQueueItem = "media-queue-item",
  MediaQueueTrigger = "media-queue-trigger",
  MediaRemaining = "media-remaining",
  MediaRestart = "media-restart",
  MediaScrubber = "media-scrubber",
  MediaSettingsTab = "media-settings-tab",
  MediaSettingsTrigger = "media-settings-trigger",
  MediaSkipBack = "media-skip-back",
  MediaSkipForward = "media-skip-forward",
  MediaSkipIntro = "media-skip-intro",
  MediaSleepTimerCancel = "media-sleep-timer-cancel",
  MediaSleepTimerOption = "media-sleep-timer-option",
  MediaSpeedOption = "media-speed-option",
  MediaSubtitles = "media-subtitles",
  MediaTextSettingsOption = "media-text-settings-option",
  MediaTextSettingsTrigger = "media-text-settings-trigger",
  MediaTranscriptToggle = "media-transcript-toggle",
  MediaVolume = "media-volume",
  MenuBar = "menu-bar",
  OnboardingScreenTitle = "onboarding-screen-title",
  OnboardingScreenContinue = "onboarding-screen-continue",
  OnboardingStackCard = "onboarding-stack-card",
  OnboardingStackCardYesButton = "onboarding-stack-card-yes-button",
  OnboardingStackCardNoButton = "onboarding-stack-card-no-button",
  OTPInput = "otp-input",
  PaymentButtonSubmit = "payment-button-submit",
  Payments = "payments",
  PaypalContainer = "paypal-container",
  PixEmailInput = "pix-email-input",
  PixNameInput = "pix-name-input",
  PixSubmitButton = "pix-submit-button",
  PixTaxIdInput = "pix-tax-id-input",
  PixTrigger = "pix-trigger",
  PostPrayerModal = "post-prayer-modal",
  PrayerMediaOptionsTrigger = "prayer-media-options-trigger",
  PromoCodeInput = "promo-code-input",
  PromoCodeSubmitButton = "promo-code-submit-button",
  PromoCodeTrigger = "promo-code-trigger",
  PromotionalOffer = "promotional-offer",
  SelectDescription = "select-description",
  SelectTrigger = "select-trigger",
  SubmitPaymentButton = "submit-payment-button",
  SubscriptionIcon = "subscription-icon",
  SubscriptionPlanActionButton = "subscription-plan-action-button",
  SubscriptionPlanTitle = "subscription-plan-title",
  SubscribeContinueButton = "subscribe-continue-button",
  SubscribeTrialOfferFree = "subscribe-trial-offer-free",
  SubscribeTrialOfferPaid = "subscribe-trial-offer-paid",
  SubscribeTrialChoiceDescription = "subscribe-trial-choice-description",
  TabBar = "tab-bar",
  Tag = "tag",
}
